import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Layout from '@/components/layout.vue'
import asynRouter from '@/router/asynRouter'
import { commonApi } from '@/api/common'
import jwtdecode from 'jwt-decode'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: asynRouter
})

// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const routerMethods = {
    //刷新token认证，判断是否登录过其他平台
	checkToken(to, from, next) {
		// 如果是钉钉扫码登录回调页，不用请求获取token
        if(to.name == 'dingtalk_callback') {
            next()
            return false;
		}
        const refreshTokenUrl = localStorage.getItem(EpetJs.Const.LoginTypeName) == 'business' ? commonApi.businessRefreshTokenUrl : commonApi.refreshTokenUrl
		EpetJs.Common.ajax('get', refreshTokenUrl, {
			platform: store.state.platformName,
			token: store.state.userInfo.token ? store.state.userInfo.token : ''
		}).then(res => {
			if (res && res.data.data && res.data.data.token) {
				this.saveUserInfo(res.data.data.token, res.data.data.refresh_token)
				if (to.name == 'login') {
					next({
						path: "/",
						replace: true
					})
				} else {
					next()
				}
			} else {
				store.commit('changeLoginState', {
					isLogin: false
				})
				if (['login','reset_login'].indexOf(to.name) == -1) {
					next({
						path: "/login?referer="+to.fullPath,
						query:{referer: to.fullPath},
						replace: true
					})
				} else {
					next();
				}
			}
		})
	},
    //保存登录状态及用户信息
	saveUserInfo(token, refresh_token) {
		var userId = jwtdecode(token).user.uid
		var userName = jwtdecode(token).user.name
		var acId = jwtdecode(token).user.acId
		var expire = jwtdecode(token).exp
		store.commit('changeLoginState', {
			isLogin: true
		})
		store.commit('saveUser', {
			userName: userName,
			userId: userId,
			acId: acId
		})
		store.commit('saveToken', {
			token: token,
			refreshToken: refresh_token,
			expire: expire
		})
	},
}


router.beforeEach((to, from, next) => {
    routerMethods.checkToken(to, from, next)
})

export default router